export enum BUTTON_VARIANTS {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  FORM = "form",
  TEXT = "text",
  LINK = "link",
}

export const BREAKPOINTS = {
  MOBILE: {
    type: "MOBILE",
    resolution: 767,
  },
  TABLET: {
    type: "TABLET",
    resolution: 1023,
  },
  SMALL_DESKTOP: {
    type: "SMALL_DESKTOP",
    resolution: 1279,
  },
  MEDIUM_DESKTOP: {
    type: "MEDIUM_DESKTOP",
    resolution: 1439,
  },
  LARGE_DESKTOP: {
    type: "LARGE_DESKTOP",
    resolution: 1919,
  },
  TV: {
    type: "TV",
    resolution: 2559,
  },
  LARGE_RESOLUTION: {
    type: "TV",
    resolution: 2560,
  },
};
